
'use strict'

import News from "./News";
import App from "../../App";
import TextString from '../../utils/TextString';

export const TYPE_GRID_VIEW = 'TYPE_GRID_VIEW';
export const TYPE_LIST_VIEW = 'TYPE_LIST_VIEW';

export class NewsItem{
    constructor(data, viewType, animIndex){
        this.main = null
        this._data = data;
        this._animIndex = animIndex;

        this.setViewType(viewType);
    }
    
    setViewType(viewType){
        let newMain = document.createElement('div');

        let arrDate = this._data.datetime.split(' ')[0].split('-');
        let date = `${parseInt(arrDate[2], 10)} ${App.monthsShort[parseInt(arrDate[1], 10) - 1]} ${arrDate[0]}`;
        
        let url = App.baseUrl + App.sitemap.news_detail.slug + this._data.slug;

        //console.log('this._data.category:', this._data.category);

        if(viewType == TYPE_GRID_VIEW){
            newMain.innerHTML = /*html*/ `<div class="col-sm-6 col-lg-4">
                                            <a href="${url}" class="card-new wow fadeInUp" data-wow-delay="0.${this._animIndex}s">
                                                <div href="${url}" class="card-new__img">
                                                    <img src="${App.filesPath + this._data.area_thumb}" alt="Sample">
                                                    <div class="card-new__tag card-new__tag--${this._data.category}">${News.categories[this._data.category]}</div>
                                                </div>
                                                <div class="card-new__title">${(new TextString(this._data.title)).cut(60)}</div>
                                                <div class="card-new__description">${(new TextString(this._data.smalltext)).cut(150)}</div>
                                                <div class="card-new__footer">
                                                    <div class="card-new__collaborators">
                                                        <div class="collaborators">
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="card-new__date">${date}</div>
                                                </div>
                                            </a>
                                        </div>`;
        }else{
            newMain.innerHTML = /*html*/`<div class="col-xxl-6">
                                            <div class="card-new card-new--list wow fadeInUp" data-wow-delay="0.${this._animIndex}s">
                                                <div class="card-new__tag card-new__tag--mobile card-new__tag--${this._data.category}">${News.categories[this._data.category]}</div>
                                                
                                                <div class="row">
                                                    <div class="col-12 col-sm-5 col-md-4 col-lg-3 col-xxl-5 col--photo">
                                                        <a href="${url}" class="card-new__img">
                                                            <img src="${App.filesPath + this._data.area_thumb}" alt="Sample">
                                                            <div class="card-new__tag card-new__tag--${this._data.category}">${News.categories[this._data.category]}</div>
                                                        </a>
                                                    </div>
                                                    <div class="col-12 col-md-8 col-lg-9 col-xxl-7 col--content">
                                                        <a href="${url}" class="card-new__title">${(new TextString(this._data.title)).cut(80)}</a>
                                                        <div class="card-new__description">${this._data.smalltext}</div>
                                                        <div class="card-new__footer">
                                                            <div class="card-new__collaborators">
                                                                <div class="collaborators">
                                                                    
                                                                </div>
                                                            </div>
                                                            <div class="card-new__date">${date}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>`;            
            
        }

        if(this._data.authors.length > 3){
            let visibleAuthors = this._data.authors.slice(0, 2);
            let authorsHolder = newMain.querySelector('.collaborators');

            visibleAuthors.forEach((author)=>{
                authorsHolder.insertAdjacentHTML('beforeend', /*html*/`<div class="collaborators__item"><img src="${App.filesPath + author.image}" class="collaborators__thumb"></div>`);
            });

            let rest = this._data.authors.length - visibleAuthors.length;

            if(rest > 0){
                authorsHolder.insertAdjacentHTML('beforeend', /*html*/`<div class="collaborators__item"><div class="collaborators__thumb collaborators__thumb--others">+${rest}</div></div>`);    
            }
        } else {
            let visibleAuthors = this._data.authors.slice(0, 3);
            let authorsHolder = newMain.querySelector('.collaborators');

            visibleAuthors.forEach((author)=>{
                authorsHolder.insertAdjacentHTML('beforeend', /*html*/`<div class="collaborators__item"><img src="${App.filesPath + author.image}" class="collaborators__thumb"></div>`);
            });

            let rest = this._data.authors.length - visibleAuthors.length;

            if(rest > 0){
                authorsHolder.insertAdjacentHTML('beforeend', /*html*/`<div class="collaborators__item"><div class="collaborators__thumb collaborators__thumb--others">+${rest}</div></div>`);    
            }
        }
        
        newMain = newMain.firstChild; 

        if(this.main != null){
            this.main.parentNode.replaceChild(newMain, this.main);
            this.main = newMain;
        }else{
            this.main = newMain;
        }
    }
}